<app-menu *ngIf="!showJobPreviewOnly" headerCSS="header-transparent"></app-menu>
<section *ngIf="showJobFilters" class="header-inner header-inner-big bg-holder text-white"
  style="background-image: url(assets/images/bg/banner-01.jpg)">
  <job-filter></job-filter>
</section>
<section class="space-ptb">
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <a *ngIf="navigatedFromManageJobs" [routerLink]="['/candidate/manage-jobs']"><span>&lt;&lt; Back to Manage
            Jobs</span></a>
      </div>
    </div>
    <div class="row widget">
      <div class="col-md-12 pl-0 pr-0 widget-box">
        <div class="job-list">
          <div class="job-list-logo">
            <img class="img-fluid" [src]="jobPreview.businessLogo" alt="" />
          </div>
          <div class="job-list-details">
            <div class="job-list-info">
              <div class="job-list-title">
                <h5 class="mb-0">{{ jobPreview.title }}</h5>
              </div>
              <div class="job-list-option">
                <ul class="list-unstyled">
                  <li>
                    <i class="fas fa-map-marker-alt pr-1"></i>{{ jobPreview.city }}, {{ jobPreview.country }}
                  </li>
                </ul>
              </div>
              <div class="job-list-option">
                <ul class="list-unstyled">
                  <li>
                    <i class="fas fa-asterisk pr-1"></i><b>Job Ref# </b>{{ jobPreview.id }}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="job-list-favourite-time">
            <a class="job-list-favourite order-2" [ngClass]="{ bookmarked: jobPreview.bookmarked }" [routerLink]=""
              (click)="onFavouriteClicked()"><i class="far fa-heart"></i></a>
            <span class="job-list-time order-1"><i class="far fa-clock pr-1"></i>{{ jobPreview.datePosted | date :
              "mediumDate" }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="widget col-lg-8 pr-0 pl-0">
        <div class="widget-box p-3">
          <div class="row">
            <div class="col-md-4 col-sm-6 mb-4">
              <div class="d-flex">
                <i class="font-xll text-primary align-self-center flaticon-worker"></i>
                <div class="feature-info-content pl-3">
                  <label class="mb-1">Job</label>
                  <span class="mb-0 font-weight-bold d-block text-dark">{{
                    jobPreview.type
                    }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mb-md-0 mb-4">
              <div class="d-flex">
                <i class="font-xll text-primary align-self-center flaticon-apartment"></i>
                <div class="feature-info-content pl-3">
                  <label class="mb-1">Industry</label>
                  <span class="mb-0 font-weight-bold d-block text-dark">{{
                    jobPreview.sector
                    }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mb-sm-0 mb-4">
              <div class="d-flex">
                <i class="font-xll text-primary align-self-center flaticon-medal"></i>
                <div class="feature-info-content pl-3">
                  <label class="mb-1">Experience</label>
                  <span class="mb-0 font-weight-bold d-block text-dark">{{ jobPreview.experience }} years</span>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mb-1">
              <div class="d-flex">
                <i class="font-xll text-primary align-self-center flaticon-mortarboard"></i>
                <div class="feature-info-content pl-3">
                  <label class="mb-1">Qualification</label>
                  <span class="mb-0 font-weight-bold d-block text-dark">{{
                    jobPreview.education
                    }}</span>
                </div>
              </div>
            </div>
            <div class="col-md-5 col-sm-6 mb-1">
              <div class="d-flex">
                <i class="font-xll text-primary align-self-center flaticon-debit-card"></i>
                <div class="feature-info-content pl-3">
                  <label class="mb-1">Offered Salary</label>
                  <span class="mb-0 font-weight-bold d-block text-dark">{{
                    jobPreview.salaryRange
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="widget-box p-3 mt-2">
          <h6 class="mb-md-1">Job Description</h6>
          <p>{{ jobPreview.description }}</p>
          <h6 class="mb-md-1">Required Knowledge, Skills, and Abilities</h6>
          <p>{{ jobPreview.skills }}</p>
        </div>
      </div>
      <!--=================================
        sidebar -->
      <div class="col-lg-4 ">
        <div class="sidebar mb-0">
          <div class="notice" *ngIf="jobPreview.applied === true">
            You have already applied for this job on
            {{ jobPreview.applicationDate | date : "mediumDate" }}
          </div>
          <div class="widget" *ngIf="showApplyControls">
            <a class="btn btn-primary btn-block" [ngClass]="{
                'disabled-anchor':
                  jobPreview.applied === true || jobPreview.expired === true
              }" [routerLink]="" (click)="onSendProposal()"><i class="far fa-paper-plane"></i>Send Proposal</a>
          </div>
          <div class="widget" *ngIf="showDiscussControls">
            <a class="btn btn-primary btn-block" [routerLink]="" (click)="onDiscussClicked()"><i class="far fa-paper-plane"></i>Discuss Job</a>
          </div>
          <div class="widget" *ngIf="showDeclineControls">
            <a class="btn btn-primary btn-block" [routerLink]="" (click)="onDeclineClicked()"><i class="far fa-paper-plane"></i>Decline Job</a>
          </div>
          <div class="widget">
            <app-report-as-malicious buttonText="Report Job" [recordIdToReport]="currentJobId"
              [recordTypeToReport]="entityTypeEnum.job"></app-report-as-malicious>
          </div>
          <div class="widget">
            <div class="jobber-company-view">
              <ul class="list-unstyled">
                <li>
                  <div class="widget-box">
                    <div class="d-flex flex-wrap align-items-center">
                      <i class="flaticon-clock fa-2x fa-fw text-primary"></i>
                      <span class="pl-3">{{ jobPreview.expiry }}</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="widget-box">
                    <div class="d-flex flex-wrap align-items-center">
                      <i class="flaticon-loupe fa-2x fa-fw text-primary"></i>
                      <span class="pl-3">{{ jobPreview.views }} Views</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="widget-box">
                    <div class="d-flex flex-wrap align-items-center">
                      <i class="flaticon-personal-profile fa-2x fa-fw text-primary"></i>
                      <span class="pl-3">{{ jobPreview.applicants }} Applications</span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          
          <div class="widget" *ngIf="showApplyControls == true && similarJobs">
            <div class="widget-title">
              <h5>Similar Jobs</h5>
            </div>
            <list-jobs [showPager]="false" [jobs]="similarJobs"></list-jobs>
          </div>
        </div>
      </div>
      <!--=================================
        sidebar -->
    </div>

    <ng-container *ngIf="shouldShowReviewAndMilestone">
      <!-- Milestones Section -->
      <div class="row widget mt-2">
        <div class="col-12 widget-box">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="milestone-hdr">Milestones</span>
            <a role="button" [routerLink]="" class="fas fa-refresh p-0" (click)="refreshMilestones()" title="Refresh"></a>
          </div>
          
          <ng-container *ngFor="let milestone of jobPreview.jobMilestones">
            <div class="row widget-box mt-1 d-flex align-items-center">
              <!-- Description -->
              <div class="col-12 col-md-3 px-0">
                {{ milestone.description }}
              </div>
              <!-- Amount -->
              <div class="col-12 col-md-1 px-0">
                ${{ milestone.amount }}
              </div>
              <!-- Date -->
              <div class="col-12 col-md-3 px-0">
                {{ milestone.startDate | date : "dd/MM/yyyy" }} - {{ milestone.endDate | date : "dd/MM/yyyy" }}
              </div>
              <!-- Progress and Payout -->
              <div class="col-12 col-md-3 px-0">
                <b>Progress:</b> {{ milestone.progressStatus.name }}
                <b>Payout:</b> {{ milestone.payoutStatus.name }}
              </div>
              <!-- Action Button -->
              <div class="col-12 col-md-2 action-div px-0 text-right" *ngIf="isProgressPending(milestone.progressStatus.id) || isInProgress(milestone.progressStatus.id)">
                <button class="btn" [ngClass]="isProgressPending(milestone.progressStatus.id) ? 'btn-primary' : 'btn-success'"
                  [title]="isProgressPending(milestone.progressStatus.id) ? 'Start milestone' : 'Complete milestone'"
                  (click)="isProgressPending(milestone.progressStatus.id)
                            ? handleMilestoneStatusChangeEvent(milestone.id, milestoneProgressStatuses.inProgress)
                            : handleMilestoneStatusChangeEvent(milestone.id, milestoneProgressStatuses.done)"
                  [disabled]="!isPaymentCleared(milestone.payoutStatus.id)">
                  <i class="fas fa-play" *ngIf="isProgressPending(milestone.progressStatus.id)"></i>
                  <i class="fas fa-check" *ngIf="isInProgress(milestone.progressStatus.id)"></i>
                </button>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    
      <!-- Reviews Section -->
      <div class="row widget mt-2">
        <div class="col-12 widget-box">
          <h6>Reviews</h6>
          <div class="row pt-1">
            <div class="col-12">
              <app-review *ngIf="!isReviewGiven" (reviewEvent)="onReviewSave($event)"></app-review>
              <ng-container *ngFor="let jobReview of jobReviews">
                <app-display-review [review]="jobReview"></app-display-review>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    
  </div>
</section>

<app-modal #confirmationModal [modalConfig]="confirmationModalConfig">
  <div>Are you sure to change milestone status to <b>{{milestoneStatus}}</b>.</div>
</app-modal>